import { CustomPopover } from '@aibees/shared/components';
import { Backdrop as BackdropBase } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Wrapper = styled(CustomPopover)``;

export const Backdrop = styled(BackdropBase)`
  z-index: 1000;
`;
